import React from 'react';
import PropTypes from 'prop-types';
import { createVariants } from './_variants';

// Tailwind-tokenized design canon Button
// Variants: primary, outline, ghost
// Sizes: sm, md, lg
const buttonClasses = createVariants({
  base:
    'inline-flex items-center justify-center select-none whitespace-nowrap align-middle font-medium rounded-md transition-theme duration-theme focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-succession-focus-ring disabled:cursor-not-allowed',
  variants: {
    // Emphasized button using tenant brand primary
    primary:
      'bg-succession-primary text-white hover:bg-succession-primary-hover shadow-succession-md hover:shadow-succession-lg',
    // Outline button on the page background, respects theme border tokens
    outline:
      'bg-succession-bg-primary text-succession-text-primary border border-succession-border hover:border-succession-border-hover hover:bg-succession-hover-bg',
    // Ghost button is minimal; primarily text with subtle hover background
    ghost:
      'bg-transparent text-succession-text-secondary hover:bg-succession-hover-bg',
  },
  sizes: {
    sm: 'text-sm px-3 py-1.5 rounded',
    md: 'text-sm px-4 py-2 rounded-md', // canonical default from HomeContainer
    lg: 'text-base px-5 py-2.5 rounded-lg',
  },
  defaultVariant: 'primary',
  defaultSize: 'md',
});

const Button = React.forwardRef(function Button(
  { as: Comp = 'button', variant = 'primary', size = 'md', className, disabled, children, ...rest },
  ref,
) {
  const classes = buttonClasses({ variant, size, className, disabled });
  return (
    <Comp ref={ref} className={classes} disabled={disabled} {...rest}>
      {children}
    </Comp>
  );
});

Button.propTypes = {
  as: PropTypes.elementType,
  variant: PropTypes.oneOf(['primary', 'outline', 'ghost']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

export default Button;


